import { Text } from '@ps-design-system/components/Text';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const SurveillanceRules = ({ surveillanceInfo, urlPrefix }) => {
  return (
    <div>
      <Text element="p" typeface="body-2-m" style={{ margin: '0' }}>
        <FormattedMessage
          id="host_rules.surveillance"
          defaultMessage="Security cameras and recording devices"
        />
      </Text>
      <Text
        element="p"
        style={{ margin: '0', marginBottom: '12px', color: '#6A6E7A' }}
      >
        {surveillanceInfo?.description || (
          <FormattedMessage
            id="host_rules.surveillance_default"
            defaultMessage="Check with your host if there are any surveillance cameras or recording devices in the space."
          />
        )}
      </Text>

      <Text element="p" style={{ margin: '0', color: '#6A6E7A' }}>
        <FormattedMessage
          id="host_rules.surveillance_prohibited"
          defaultMessage="Recording devices in bathrooms or dressing rooms are prohibited by the {terms}."
          values={{
            terms: (
              <a
                href={`https://www.peerspace.com${urlPrefix}/legal/terms`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FormattedMessage
                  id="host_rules.services_agreement"
                  defaultMessage="Peerspace Services Agreement"
                />
              </a>
            )
          }}
        />
      </Text>
    </div>
  );
};

SurveillanceRules.displayName = 'SurveillanceRules';
SurveillanceRules.propTypes = {
  surveillanceInfo: PropTypes.object,
  urlPrefix: PropTypes.string
};
